import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ApiService } from '../../services/api.service';

@Component({
    selector: 'app-sales-installation-partner-select',
    imports: [CommonModule, FormsModule],
    templateUrl: './sales-installation-partner-select.component.html',
    styleUrls: ['./sales-installation-partner-select.component.css']
})
export class SalesInstallationPartnerSelectComponent implements OnChanges {
  @Input() label = 'Sales & Installation Partner';
  @Input() placeholder = 'Select Sales & Installation Partner';
  @Input() value: number | string | null = null;
  @Input() currentLabel = '';
  @Input() required = false;
  @Input() activeOnly = true;
  @Input() disabled = false;
  @Input() mode: 'lead' | 'form' = 'lead';
  @Output() valueChange = new EventEmitter<number | null>();

  options: any[] = [];

  constructor(private apiService: ApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeOnly'] || !this.options.length) {
      this.loadOptions();
    }
  }

  loadOptions(): void {
    const filters = this.activeOnly ? { active_only: '1' } : {};
    this.apiService.listSalesInstallationPartners(1, 500, filters).subscribe({
      next: (response: any) => {
        this.options = Array.isArray(response)
          ? response
          : response?.results || response?.data || [];
      },
      error: () => {
        this.options = [];
      }
    });
  }

  get normalizedValue(): number | null {
    if (this.value === '' || this.value === null || this.value === undefined) {
      return null;
    }
    return Number(this.value);
  }

  get renderedOptions(): any[] {
    const selectedId = this.normalizedValue;
    if (!selectedId) {
      return this.options;
    }

    const hasSelectedOption = this.options.some((option) => Number(option.id) === selectedId);
    if (hasSelectedOption || !this.currentLabel) {
      return this.options;
    }

    return [
      { id: selectedId, company_name: this.currentLabel },
      ...this.options,
    ];
  }

  onChange(value: string): void {
    this.valueChange.emit(value ? Number(value) : null);
  }
}
